<template>
  <div class="component-body flex">
    <el-rate v-model="value1"></el-rate>
    <el-rate class="margin-left-35"
        v-model="value"
        disabled
        show-score
        text-color="#ff9900"
        score-template="{value}">
    </el-rate>
  </div>
</template>

<script>
export default {
  name: 'index',
  data () {
    return {
      value1: null,
      value: 3.7,
      colors: ['#99A9BF', '#F7BA2A', '#FF9900']  // 等同于 { 2: '#99A9BF', 4: { value: '#F7BA2A', excluded: true }, 5: '#FF9900' }
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/components/13/Rate/index.vue